import { render, staticRenderFns } from "./twilio.vue?vue&type=template&id=0b8f0073&"
import script from "./twilio.vue?vue&type=script&lang=js&"
export * from "./twilio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports